jQuery(document).ready(function(){
    AOS.init();
}); // end document ready event



$(window).scroll(function(e) {
    var header = $('div.header'),
        startedOffset = 10,
        pageOffset = window.pageYOffset;

    // ak header dosiahol hranicu alebo je POD nou, zapni class
    //if(pageOffset >= (header.outerHeight()) && pageOffset < (startedOffset + header.outerHeight())) {
    if(pageOffset >= startedOffset) {
        if(header.hasClass("header-scrolling") === false){
            header.addClass("header-scrolling");
            //header.css('top', -header.outerHeight());
        }
    }

    // ak je header NAD hranicou, vypni class
    //if(pageOffset < (header.outerHeight()))
    if(pageOffset < startedOffset)
    {
        if(header.hasClass("header-scrolling") === true){
            header.removeClass("header-scrolling");
            header.css('top', 0);
        }
    }
}); // end scroll event